import React from "react";
import { Dialog } from "primereact/dialog";

const CategoryModal = ({ visible, setVisible, categoriesByClient = [] }) => {
  return (
    <Dialog
      header="CATEGORIES"
      visible={visible}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      style={{ width: "35vw" }}
      closable
      draggable={false}
      resizable={false}
      modal
    >
      <div className="table-responsive">
        <table className="table table-borderless mb-0 clientsTable">
          <thead>
            <tr
              className="text-muted text-uppercase"
              style={{ fontSize: "12px", borderBottom: "1px solid lightgray" }}
            >
              <th style={{ width: "20%" }}>SR #</th>
              <th>CATEGORY NAME</th>
            </tr>
          </thead>
          <tbody>
            {categoriesByClient.length > 0 ? (
              categoriesByClient.map((category, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{category}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-muted">
                  No Categories Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Dialog>
  );
};

export default CategoryModal;
